import {
  defaultGetter,
  createSetter,
  defaultSetter
}                                        from 'rewire-common';
import LogIcon                           from '@material-ui/icons/AssignmentOutlined';
import DataQueries                       from '../graphql/Queries';
import employeeDialogModel               from '../schedule/EmployeeDialogModel';
import EmployeeEditorView                from './EmployeeEditorView';
import EmployeeEditPanelHeaderView       from './EmployeeEditPanelHeaderView';
import EmployeeEditPanelView             from './EmployeeEditPanelView';
import mainPageModel                     from '../main-navigation/MainPageModel';
import archiveDeleteEmployeeDialogModel  from './ArchiveDeleteEmployeeDialogModel';
import { MasterDataSettingsModel }       from './MasterDataSettingsModel';
import { DefaultSchema, IEditPanelView } from './SettingsModel';
import { EmployeeSort }                  from '../DataTypes';
import auditLogDialogModel               from '../audit/AuditLogDialogModel';
import { getPhoneString }                from '../utility/Formatters';
import { IAuditLogFilters }              from '../audit/AuditLogListModel';

function hash(str: string): number {
  let hash = 0, i, chr;
  if (str.length === 0) return hash;
  for (i = 0; i < str.length; i++) {
    chr   = str.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
}

const EmployeeSchema = `
  ${DefaultSchema}
  email
  isPayable
  archived
  phone {
    home
    mobile
    work
    fax
    workFax
  }
`;

function isPayable(obj: any) {
  return (obj?.isPayable) ? 'paid' : 'test';
}

export default class EmployeeSettingsModel extends MasterDataSettingsModel {
  constructor() {
    super('Employees', 'employees', employeeDialogModel, [
      { label: 'Email',     get: defaultGetter('email'), set: defaultSetter('email'), icon: 'email' },
      { label: 'Phone',     get: (item: any) => item?.phone && getPhoneString(item.phone.home),    set: createSetter(['phone', 'home']),    icon: 'phone' },
      { label: 'IsPayable', get: isPayable, set: defaultSetter('isPayable'), icon: 'attach_money' },
    ]);
    this.EditPanelView       = EmployeeEditPanelView as IEditPanelView;
    this.EditPanelHeaderView = EmployeeEditPanelHeaderView;
    this.EditPanelFormView   = EmployeeEditorView;
  }

  get _canAddItem(): boolean {
    return mainPageModel.canAddEmployees;
  }

  get _canEditItem(): boolean {
    return mainPageModel.canEditEmployees;
  }

  get _canDeleteItem(): boolean {
    return mainPageModel.canDeleteEmployees;
  }

  getDefaultEditPanelHeaderOptionsItems() {
    const optionsItems = super.getDefaultEditPanelHeaderOptionsItems();
    optionsItems.push(...[
      {name: 'auditLog', title: 'View Audit Log', icon: LogIcon, onClick: this.loadAuditLogDialog, closeOnClick: true, disabled: () => !this.selectedItem },
    ]);

    return optionsItems;
  }

  getOtherSortMenuItems(): {name: string, title: string}[] {
    return [
      {name: 'email', title: 'Email'}
    ];
  }

  protected async _load(filter: {search?: string}, sort?: EmployeeSort) {
    const results   = (await DataQueries.getEmployees(EmployeeSchema, filter, sort, this.paging.itemsPerPage, this.paging.currentPage));
    for (const employee of results.data as any[]) {
      employee.url = `https://picsum.photos/id/${(Math.abs(hash(employee.id) % 1000)) + 1}/60/60?blur=2`;
    }
    this.setItems(results.data);
    return results;
  }

  archive = async () => {
    archiveDeleteEmployeeDialogModel.load(this.selectedItem, 'archive');
  };

  loadAuditLogDialog = () => {
    const filter = {types: ['employee']} as IAuditLogFilters;
    if (this.selectedItem?.id) {
      filter.entityIds = [this.selectedItem.id];
    }
    auditLogDialogModel.load(filter);
  };

  handleArchiveOnSubmit = () => {
    this.paging.load(true);
  };

  removeItem = async () => {
    if (!this.selectedItem) return;
    archiveDeleteEmployeeDialogModel.load(this.selectedItem, 'delete');
  };

  handleDeleteOnSubmit = () => {
    const selectedIdx = this.state.items.findIndex(i => i.id === this.selectedItem.id);
    if (selectedIdx >= 0) this.state.items.splice(selectedIdx, 1);
    this._selectItem(undefined);
  };

  activate() {
    const isActive = this.isActive;
    super.activate();
    if (!isActive) {
      archiveDeleteEmployeeDialogModel.onEvent.addListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteEmployeeDialogModel.onEvent.addListener('delete', this.handleDeleteOnSubmit);
    }
  }

  deactivate() {
    const isActive = this.isActive;
    super.deactivate();
    if (isActive) {
      archiveDeleteEmployeeDialogModel.onEvent.removeListener('archive', this.handleArchiveOnSubmit);
      archiveDeleteEmployeeDialogModel.onEvent.removeListener('delete', this.handleDeleteOnSubmit);
    }
  }
}
